import React, { useEffect } from "react";
import Footer from "../../common/footer";
import Header from "../../common/header";



function ProjectDetails1() {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scroll to the top of the page
    }, []);
    return (
        <div>
            <Header/>
            <section className="blog-section padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 sm-padding">
                            <div className="row-gap">
                                <div className="service-details">
                                    <div className="service-featured-img">
                                        <img src="assets/img/ser1.jpg" alt="img" style={{ width: '100%', height: 'auto' }} />
                                    </div>
                                        <h2>Jewellery Software</h2>
                                        <p>TITA TECHNOLOGIES specializes in providing tailored software solutions for the jewellery industry, addressing complex business needs with ease. Leveraging in-depth industry knowledge, the software is designed to align with current jewellery trends, offering comprehensive and customizable features for all jewellery businesses.</p>
                                        <h2>Key Features</h2>
                                    <div className="service-features">
                                        <ul className="check-list">
                                            <li><i className="fa-solid fa-thumbs-up" />Inventory Management</li>
                                            <li><i className="fa-solid fa-thumbs-up" />Customer Relationship Management</li>
                                            <li><i className="fa-solid fa-thumbs-up" />Sales and Purchase Management</li>
                                            <li><i className="fa-solid fa-thumbs-up" />Accounting and Financial Management</li>
                                        </ul>
                                        <ul className="check-list">
                                            <li><i className="fa-solid fa-thumbs-up" />Point of Sale (POS)</li>
                                            <li><i className="fa-solid fa-thumbs-up" />Reporting and Analytics</li>
                                            <li><i className="fa-solid fa-thumbs-up" />Customizable and Scalable</li>
                                            <li><i className="fa-solid fa-thumbs-up" />Integration with Other Systems</li>
                                        </ul>
                                    </div>
                                    <p>The software ensures that your invoices are generated quickly and accurately, following local and international tax laws. It supports multiple tax rates, discounts, and exemptions based on your geographical location or customer type. The system automates tax calculations, ensuring compliance with changing tax regulations. Whether it's sales tax, VAT, or other taxes, your invoices will always be up-to-date and legally compliant, helping you avoid penalties and reduce administrative burden.</p>
                                    <ul className="post-details-gallery">
                                        <li><img src="assets/img/ser2.jpg" alt="img" /></li>
                                        <li><img src="assets/img/ser3.jpg" alt="img" /></li>
                                    </ul>
                                    <h2>Core Services :</h2>
                                    
                                    <ul className="check-list">
                                        <li><i className="fa-solid fa-thumbs-up" />Track stock levels, monitor product movement, and optimize inventory.</li>
                                        <li><i className="fa-solid fa-thumbs-up" />Streamline sales, manage transactions, and generate receipts.</li>
                                        <li><i className="fa-solid fa-thumbs-up" />Manage customer orders, track status, and automate notifications.</li>
                                        <li><i className="fa-solid fa-thumbs-up" />Store customer data, track interactions, and analyze purchasing habits.</li>
                                        <li><i className="fa-solid fa-thumbs-up" />Generate sales reports, track profits, and analyze business performance.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/*Blog Grid*/}
                        <div className="col-lg-4 sm-padding">
                            
                            {/*Categories*/}
                            <div className="sidebar-widget">
                                <div className="widget-title">
                                    <h3>Development Languages</h3>
                                </div>
                                <ul className="thumb-post">
                                    <li>
                                    <div className="thumb">
                                    </div>
                                        <div className="thumb-post-info">
                                            <h3><a >For Android apps</a></h3>
                                            <a  className="date">Flutter</a>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="thumb">
                                        </div>
                                        <div className="thumb-post-info">
                                            <h3><a >For Windows desktop applications</a></h3>
                                            <a  className="date">C#</a>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="thumb">
                                        </div>
                                        <div className="thumb-post-info">
                                            <h3><a >MySQL: For relational databases</a></h3>
                                            <a  className="date">Database Management
                                            </a>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="thumb">
                                        </div>
                                        <div className="thumb-post-info">
                                            <h3><a >SQL Server: For enterprise-level relational databases</a></h3>
                                            <a  className="date">Database Management
                                            </a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            {/*Recent Thumb Post*/}
                            <div className="sidebar-widget sidebar-banner">
                                <a ><img src="assets/img/ser8.jpg" alt="banner" /></a>
                            </div>
                            {/*Banner*/}
                            
                            {/*Tags*/}
                        </div>
                        {/*Sidebar*/}
                    </div>
                </div>
            </section>
        <Footer/>
        </div>

    )
}

export default ProjectDetails1;
